export default "__VITE_ASSET__CtIlIw61__"